import API from './base';

class NetworksReviewsApi extends API {
  getReviews = ({
    limit, page, networkId, status, source, schoolId,
  }) => {
    const searchParams = new URLSearchParams({
      limit: `${limit ?? 10}`,
      page: `${page ?? 1}`,
    });

    if (status) {
      searchParams.append(`${status}`, '');
    }

    if (source) {
      searchParams.append('source', source);
    }

    if (schoolId) {
      searchParams.append('school_id', schoolId);
    }

    return this.get(`/api/web/v1/networks/${networkId}/reviews`, searchParams);
  };

  getSchools = ({ networkId }) => this.get(`/api/web/v1/networks/${networkId}/schools`);
}

export default new NetworksReviewsApi();
